let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j9Ncr")).then(() => parcelRequire('dWg6W'));